import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Loader } from "lucide-react";
import { cva } from "class-variance-authority";

type IconButtonProps = React.ComponentProps<"button"> & {
    loading?: boolean
    children: ReactNode
    intent: "primary" | "secondary" |  "warning" | "error" | "default"
}


const IconButton = ({
    children,
    disabled,
    intent,
    loading,
    className,
    ...props
}: IconButtonProps) => {

    const buttonClass = () => {
        const defaultClass = "relative inline-flex justify-center items-center rounded-md font-medium border border-transparent bg-transparent p-1"

        const config = {
            variants: {
                intent: {
                    primary: "hover:bg-primary-50 hover:border-primary text-primary",

                    secondary: "hover:bg-secondary-50 hover:border-secondary-100 text-secondary",

                    warning: "hover:bg-amber-50 hover:border-amber-400 text-amber-800",

                    error: "hover:bg-rose-50 hover:border-rose-400 text-rose-800",

                    default: "hover:bg-zinc-50 hover:border-zinc-400 text-zinc-600"
                }
            }
        }

        return cva(defaultClass, config)({
            intent: intent,
        })
    }


    return (

        <button
            className={twMerge(buttonClass(), className)}
            disabled={loading || disabled}
            {...props}
        >

            {
                loading && (
                    <div className="absolute z-10 inset-0 flex justify-center items-center">
                        <Loader 
                            className="w-4 h-4 animate-spin" 
                        />
                    </div>
                )
            }

            <span className={twMerge(loading && "invisible")}>
                {children}
            </span>
        </button>
    )
}

export default IconButton